import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { sessionStorageKey } from 'src/app/doctors-station/doctors-station.constants';
import { FaviconSwitchComponent } from 'src/app/shared/components/base-reset-password/favicon-switch.component';
import { GtmService } from 'src/app/shared/services/gtm.servie';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-lasuite-register-send',
  templateUrl: './lasuite-register-send.component.html',
  styleUrls: ['../style/global.css', './lasuite-register-send.component.css'],
})
export class LasuiteRegisterSendComponent
  extends FaviconSwitchComponent
  implements OnInit
{
  email?: string;
  initialized = false;
  gtmService: GtmService;
  constructor(
    private title: Title,
    gtmService: GtmService,
    public router: Router
  ) {
    super();
    this.gtmService = gtmService;
  }

  ngOnInit(): void {
    const gtmId = environment.apps[this.clientId].gtm?.id;
    if (gtmId) {
      this.gtmService.setGtmId(gtmId);

      this.gtmService.addGtmToDom();
    }
    // ログイン処理の瞬間に控えたメールアドレスを取得
    this.email =
      sessionStorage.getItem(sessionStorageKey.verifyEmail) || undefined;
    this.title.setTitle(`認証用URL送信完了 | ${this.pageTitle}`);
    setTimeout(() => {
      this.initialized = true;
    }, 1000);
  }

  get isOem() {
    return /oem/g.test(environment.apps[this.clientId]?.type);
  }

  get pageTitle() {
    return environment.apps[this.clientId]?.pageTitle || '';
  }

  get oemId() {
    return environment.apps[this.clientId]?.oemConfig?.id;
  }

  navigateToLogin() {
    if (location.search.includes('response_type')) {
      location.pathname = '/login';
    } else {
      const app = environment.apps[this.clientId];
      const url = app.customUrls?.gotoAppTop || app.appUrl;
      location.href = `${url}`;
    }
  }
}
